import { render, staticRenderFns } from "./SidebarUITesting.vue?vue&type=template&id=3a342342"
import script from "./SidebarUITesting.vue?vue&type=script&lang=js"
export * from "./SidebarUITesting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports